import { Converter } from '../types/converter';

export const fuelConsumptionConverter: Converter = {
  id: 'fuelConsumption',
  name: 'Fuel Consumption Converter',
  icon: 'Fuel',
  categories: ['common', 'engineering'],
  units: [
    // Distance per volume units
    { name: 'Meter/liter', symbol: 'm/L', factor: 1 },
    { name: 'Exameter/liter', symbol: 'Em/L', factor: 1e18 },
    { name: 'Petameter/liter', symbol: 'Pm/L', factor: 1e15 },
    { name: 'Terameter/liter', symbol: 'Tm/L', factor: 1e12 },
    { name: 'Gigameter/liter', symbol: 'Gm/L', factor: 1e9 },
    { name: 'Megameter/liter', symbol: 'Mm/L', factor: 1e6 },
    { name: 'Kilometer/liter', symbol: 'km/L', factor: 1000 },
    { name: 'Hectometer/liter', symbol: 'hm/L', factor: 100 },
    { name: 'Dekameter/liter', symbol: 'dam/L', factor: 10 },
    { name: 'Centimeter/liter', symbol: 'cm/L', factor: 0.01 },
    
    // Miles per volume
    { name: 'Mile (US)/liter', symbol: 'mi/L', factor: 1609.344 },
    { name: 'Nautical mile/liter', symbol: 'n.mile/L', factor: 1852 },
    { name: 'Nautical mile/gallon (US)', symbol: 'n.mile/gal (US)', factor: 7006.179883 },
    { name: 'Kilometer/gallon (US)', symbol: 'km/gal (US)', factor: 3785.411784 },
    { name: 'Mile/gallon (US)', symbol: 'mi/gal (US)', factor: 6093.49033 },
    { name: 'Mile/gallon (UK)', symbol: 'mi/gal (UK)', factor: 7316.797183 },
    
    // Meter per various volumes
    { name: 'Meter/gallon (US)', symbol: 'm/gal (US)', factor: 3.785411784 },
    { name: 'Meter/gallon (UK)', symbol: 'm/gal (UK)', factor: 4.54609 },
    { name: 'Meter/cubic meter', symbol: 'm/m³', factor: 0.001 },
    { name: 'Meter/cubic centimeter', symbol: 'm/cm³', factor: 1000 },
    { name: 'Meter/cubic yard', symbol: 'm/yd³', factor: 0.764554857984 },
    { name: 'Meter/cubic foot', symbol: 'm/ft³', factor: 0.028316846592 },
    { name: 'Meter/cubic inch', symbol: 'm/in³', factor: 1.6387064e-5 },
    { name: 'Meter/quart (US)', symbol: 'm/qt (US)', factor: 0.946352946 },
    { name: 'Meter/quart (UK)', symbol: 'm/qt (UK)', factor: 1.1365225 },
    { name: 'Meter/pint (US)', symbol: 'm/pt (US)', factor: 0.473176473 },
    { name: 'Meter/pint (UK)', symbol: 'm/pt (UK)', factor: 0.56826125 },
    { name: 'Meter/cup (US)', symbol: 'm/cup (US)', factor: 0.2365882365 },
    { name: 'Meter/cup (UK)', symbol: 'm/cup (UK)', factor: 0.284130625 },
    { name: 'Meter/fluid ounce (US)', symbol: 'm/fl oz (US)', factor: 0.0295735295625 },
    { name: 'Meter/fluid ounce (UK)', symbol: 'm/fl oz (UK)', factor: 0.0284130625 },
    
    // Volume per distance
    { name: 'Liter/meter', symbol: 'L/m', factor: 1 },
    { name: 'Liter/100 km', symbol: 'L/100 km', factor: 0.01 },
    { name: 'Gallon (US)/mile', symbol: 'gal (US)/mi', factor: 0.00235214583 },
    { name: 'Gallon (US)/100 mi', symbol: 'gal (US)/100 mi', factor: 0.0235214583 },
    { name: 'Gallon (UK)/mile', symbol: 'gal (UK)/mi', factor: 0.00282481053 },
    { name: 'Gallon (UK)/100 mi', symbol: 'gal (UK)/100 mi', factor: 0.0282481053 }
  ]
};
